import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import {CssBaseline, Divider, Drawer,
        Toolbar, Typography, Avatar, IconButton, ButtonBase, withWidth} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActionCreators from "../../store/actions";
import logo from '../../images/ets-logo2.png';
import {themeTypeToBool} from "../../utils/helpers";
import MenuButtons from "./MenuButtons";

export const minDrawerWidth = 240;
const minDrawerCloseWidth = 73;

const useStyles = (theme => ({
    root: {
        display: "flex"
    },
    drawer: {
        width: minDrawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: 'hidden',
        width: minDrawerWidth
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: minDrawerCloseWidth,
        [theme.breakpoints.up('sm')]: {
            width: minDrawerCloseWidth,
        },
    },
    contentDrawerOpen: {
        width: `calc(100% - ${minDrawerWidth}px)`,
    },
    contentDrawerClose: {
        width: `calc(100%) - ${minDrawerCloseWidth}`
    },
    toolbar: {
        ...theme.mixins.toolbar,
    },
    logo: {
        marginRight: 5,
        width: 80,
        height: 60,
        marginLeft: -30,
    },
    drawerPaper: {
        background: themeTypeToBool(theme.palette.type) ? "#43425D" : "#3B3B53"
    },
    content: {
        flexGrow: 1,
    },
    hide: {
        display: "none"
    },
    closeDrawerButton: {
        color: "#fff",
        position: "absolute",
        right: 0
    },
    fleetLabel: {
        transformOrigin: "top left",
        transform: "scaleX(2.02)",
        letterSpacing: 3,
    }
}));

class MenuBar extends Component {

    handleDrawerOpen() {
        this.props.changeDrawer();
        window.dispatchEvent(new CustomEvent('resize'));
    }

    handleDrawerClose() {
        this.handleDrawerOpen();
    }

    componentDidMount() {
        if((this.props.width === "md" || this.props.width === "sm" || this.props.width === "xs") && this.props.isDrawerOpen)
            this.props.closeDrawer();
    }

    render() {
        const { classes, isDrawerOpen } = this.props;

        const drawer = (
            <div>
                <div className={classes.toolbar}>
                    <Toolbar>
                        <Avatar
                            className={classes.logo}
                            alt="ETS_logo"
                            src={logo}
                            component={ButtonBase}
                            disableTouchRipple
                            onClick={this.handleDrawerOpen.bind(this)} />
                        <div>
                        <Typography variant="h6" noWrap color="textSecondary" style={{letterSpacing: 2}}>
                            QSAFE24
                        </Typography>
                        <Typography variant="body2" color="textSecondary" className={classes.fleetLabel}>
                            FLOTA
                        </Typography>
                        </div>
                        <IconButton
                            onClick={this.handleDrawerClose.bind(this)}
                            className={clsx(classes.closeDrawerButton, {
                                [classes.hide]: !isDrawerOpen
                            })}
                            >
                            <ChevronLeftIcon />
                        </IconButton>
                    </Toolbar>
                </div>
                <Divider />
                <MenuButtons />
            </div>
        );

        return (
            <div className={classes.root}>
                <CssBaseline />
                        <Drawer
                            classes={{
                                paper: clsx(classes.drawerPaper, {
                                    [classes.drawerOpen]: isDrawerOpen,
                                    [classes.drawerClose]: !isDrawerOpen
                                })
                            }}
                            className={clsx(classes.drawer, {
                                [classes.drawerOpen]: isDrawerOpen,
                                [classes.drawerClose]: !isDrawerOpen
                            })}
                            variant="permanent"
                            open
                        >
                            {drawer}
                        </Drawer>
                <main className={clsx(classes.content, {
                    [classes.contentDrawerOpen]: isDrawerOpen,
                    [classes.contentDrawerClose]: !isDrawerOpen
                })}
                >
                    {this.props.children}
                </main>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        themeType: state.requestReducer.themeType,
        isDrawerOpen: state.requestReducer.isDrawerOpen,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreators, dispatch);
};

MenuBar.propTypes = {
    classes: PropTypes.object,
    width: PropTypes.string,
    children: PropTypes.node,
    //redux
    isGpsEnabled: PropTypes.bool,
    changeDrawer: PropTypes.func,
    closeDrawer: PropTypes.func
};

export default compose(
    withStyles(useStyles),
    withWidth(),
    connect(mapStateToProps, mapDispatchToProps)
)(MenuBar);
